import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    margin: theme.spacing(4),
  },
});
